import { Controller } from "@hotwired/stimulus";

// Lets users browse the available audit event types and insert them into the
// search box. Clicking a type appends a `type:NAME` token to the search field
// (de-duplicating) and submits the form.
//
// Connects with data-controller="audit-log-search" on the search <form>.
export default class extends Controller<HTMLFormElement> {
  static targets = ["input"];

  declare readonly inputTarget: HTMLInputElement;

  add(event: Event & { params: { type: string } }) {
    const type = event.params.type;
    if (!type) {
      return;
    }

    const token = `type:${type}`;
    const current = this.inputTarget.value.trim();
    const tokens = current.length > 0 ? current.split(/\s+/) : [];

    if (!tokens.includes(token)) {
      tokens.push(token);
      this.inputTarget.value = tokens.join(" ");
    }

    this.element.requestSubmit();
  }
}
